import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Pageheader } from './global-components/page-header';
import PropertySection from './section-components/property-section';
import bgImage from '../assets/img/bg/residential.webp';
import ResidentialFilter from './common/ResidentialFilter';

const ResidentialPage = () => {
    const location = useLocation();
    const [isSearchMode, setIsSearchMode] = useState(false);
    const [filters, setFilters] = useState({
        type: 'residential',
        keyword: '',
        area: '',
        sqYards: ''
    });

    // Handle incoming filters from navigation
    useEffect(() => {
        if (location.state?.filters && location.state?.fromSearch) {
            const incomingFilters = location.state.filters;
            const mappedFilters = {
                ...incomingFilters,
                type: 'residential', // Ensure type stays residential for this page
                // Map size fields appropriately
                sqYards: incomingFilters.sqYards || incomingFilters.size || ''
            };

            setFilters(mappedFilters);

            // If there are actual search criteria, trigger search mode
            const hasSearchCriteria = incomingFilters.keyword ||
                incomingFilters.area ||
                incomingFilters.sqYards ||
                incomingFilters.size;

            if (hasSearchCriteria) {
                setIsSearchMode(true);
            }
        }
    }, [location.state]);

    const handleFilterChange = (newFilters) => {
        setFilters(newFilters);
        // Don't set search mode for filter changes - only for explicit search
    };

    const handleSearch = (searchFilters, isSearch = false) => {
        console.log('Searching with filters:', searchFilters);
        console.log('isSearch flag:', isSearch);
        setFilters(searchFilters);
        if (isSearch) {
            console.log('Setting search mode to true');
            setIsSearchMode(true); // Set search mode when search is triggered
            // Reset search mode after a brief delay to allow the effect to trigger
            setTimeout(() => {
                setIsSearchMode(false);
            }, 100);
        }
    };

    return (
        <div>
            <Pageheader headertitle="Residential Properties" bgImage={bgImage} />
            <ResidentialFilter
                filters={filters}
                onFilterChange={handleFilterChange}
                onSearch={handleSearch}
            />
            <PropertySection
                type="residential"
                title="Looking for residential plots for sale in Amaravati?"
                description="Royale Spaces offers premium residential open plots in Amaravati's most sought-after locations. Our properties are CRDA-approved, strategically located near schools, hospitals, and major infrastructure. Whether you're building your dream home or investing for the future, we provide verified plots with clear titles, complete legal documentation, and transparent pricing for a hassle-free experience."
                filters={filters}
                isSearchMode={isSearchMode}
                initialPropertiesPerPage={6}
            />
        </div>
    );
};

export default ResidentialPage;
